<template>
  <b-modal
    :id="'transactions-' + item.id.toString()"
    centered
    hide-footer
    hide-header
    size="xl"
  >
    <ProcessingGif v-if="processing" :classes="'popup-processing-image'" :processing="processing" />
    <div v-else-if="item.show_transactions && item.transactions && item.transactions.length">
      <div class="centered-block">
        <div class="step-title">Your Transactions</div>
      </div>
      <b-table striped hover :items="transactions" :fields="transactionFields" class="transactions-table"></b-table>
    </div>
    <div v-else>
      <div class="centered-block">
        <div class="step-title">No transactions found</div>
      </div>
    </div>
    <b-link block class="centered-block close-button" variant="secondary" @click="close()">&times;</b-link>
  </b-modal>
</template>

<script>
import axios from 'axios'
import {formatCurrency, getShortDate} from '@/utils'
import {TranResponseStrings} from '@/constants'
import ProcessingGif from '@/components/ProcessingGif'

export default {
  name: 'Transactions',
  components: {ProcessingGif},
  props: {
    item: Object
  },
  data: function() {
    return {
      processing: true
    }
  },
  computed: {
    transactions: function() {
      let transactions = []

      for (let transaction of this.item.transactions) {
        transactions.push({
          date: getShortDate(transaction.created),
          status: TranResponseStrings[transaction.response_type],
          amount: formatCurrency(transaction.amount, this.item.order.currency),
          refund: formatCurrency(transaction.refund_amount, this.item.order.currency)
        })
      }

      return transactions
    },
    transactionFields: function() {
      let fields = [
        {key: 'date'},
        {key: 'status'},
        {key: 'amount'}
      ]
      if (this.item.transactions.some(item => Number(item.refund_amount) > 0)) {
        fields.push({key: 'refund'})
      }
      return fields
    }
  },
  methods: {
    close: function() {
      this.$bvModal.hide('transactions-' + this.item.id.toString())
    }
  },
  created() {
    if (!this.item.show_transactions) {
      this.processing = false // not allowed to show transactions, so nothing to do
    } else if (this.item.transactions && this.item.transactions.length) {
      this.processing = false // we already have them, so nothing to do
    } else {
      axios.get('/order_items/' + this.item.id.toString() + '/transactions/')
        .then(result => {
          console.log(result)
          this.item.transactions = result.data
          this.processing = false
        }, error => {
          console.error(error)
          this.processing = false
        })
    }
  }
}
</script>

<style scoped>

</style>
